<!--月结商品设置-->
<template>
  <el-dialog title="配置月结商品" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-form ref="form1">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title" style="width: 1160px;display: inline-block;">
        <span class="titlecolor">
          <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodDetailSel(0)">选择商品</span>
          <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodCategorySel(0)">选择类别</span>
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="商品名称"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="categoryname"
                label="商品类别"
                align="left"
                header-align="center">
                <template slot-scope="scope">
                  {{!scope.row.seedcode?scope.row.categorycode+' '+scope.row.categoryname:scope.row.categoryname}}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <a size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                     type="danger"
                     @click="handleDelete(scope.$index, scope.row,0)">删除
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title" style="width: 1160px;display: inline-block;">
        <span class="titlecolor">排除下列商品
        <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodDetailSel(1)">选择商品</span>
        <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodCategorySel(1)">选择类别</span>
        </span>
          </template>
          <el-row :gutter="20">
            <el-table
              :data="tableDataSkim"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="商品名称"
                align="left"
                header-align="center"
              >
              </el-table-column>
              <el-table-column
                prop="categoryname"
                label="商品类别"
                align="left"
                header-align="center">
                <template slot-scope="scope">
                  {{scope.row.categoryname}}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <a
                    size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row,1)">删除
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <JxcgooddetailSel ref="JxcgooddetailSel" :isShowCheckBox="true"
                      @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    <JxcgoodscategorySel ref="JxcgoodscategorySel" :isShowCheckBox="true"
                         @afterSelectCode="afterSelectCategoryCode"></JxcgoodscategorySel>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
      <el-button type="primary" @click="saveData" v-if="CanEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {getlistByCode} from '@/api/set/accountageset';
  import JxcgooddetailSel from '../../set/jxcgooddetail/JxcgooddetailSel'
  import JxcgoodscategorySel from '../../set/jxcgoodscategory/JxcgoodscategorySel'
  export default {
    name: "SettingMenthodEdit",
    data() {
      return {
        dialogFormVisible: false,
        activeNames: ['1', '2'],
        tableData: [],
        tableDataSkim: [],//撇除的产品
        delUnitguids: [],
        loading: false,//控制按钮显示
        formLabelWidth: '120px',
        isSkim: 0,//1表示添加撇除产品
        userInfoModel: {},//缓存数据
        tokenModel: {},
        cusSerial: '',
        CanEdit: false,
      }
    },
    props: {
    },
    methods: {
      //删除明细
      handleDelete(index, row, isSkim) {
        if (isSkim == 1)
          this.tableDataSkim.splice(index, 1)
        else
          this.tableData.splice(index, 1)
      },
      //显示商品选择页面
      showGoodDetailSel(isSkim) {
        this.isSkim = isSkim
        this.$refs.JxcgooddetailSel.show()
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        var datas=this.tableData;
        if (this.isSkim == 1) {
          datas=this.tableDataSkim;
        }
        for (let i in arr) {
          let biaoji = 0
          for (let j in datas) {
            //判读该商品是否属于
            if ((!datas[j].seedcode && arr[i].categorycode.startsWith(datas[j].categorycode)) ||
              (datas[j].seedcode && datas[j].seedcode == arr[i].seedcode
            )) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            datas.push({
              categoryname: '',//arr[i].lname,
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              categorycode: ''//arr[i].categorycode, setmethod: this.showPriceSet ? 1 : 0
            })
          }
        }
        if (count > 0) {
          this.$message({
            message: "商品已存在，或者属于已选择类别下的商品",
            type: 'info',
            duration: 1500
          })
        }

      },
      //选择商品类别
      showGoodCategorySel(isSkim) {
        this.isSkim = isSkim
        this.$refs.JxcgoodscategorySel.show()
      },
      //选择商品类别后执行
      afterSelectCategoryCode(arr) {
        var datas=this.tableData;
        if (this.isSkim == 1) {
          datas=this.tableDataSkim;
        }
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in datas) {
            if (datas[j].categorycode==arr[i].categorycode) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            datas.push({
              categorycode: arr[i].categorycode,
              categoryname: arr[i].categoryname
            })
          }
        }

      },
      //保存
      saveData(serial) {
        this.loading = true
        var catecode = ''
        var seedcode = ''
        for (let i in this.tableData) {
          var item = this.tableData[i];
          if (item.seedcode) {
            seedcode += (seedcode == '' ? '' : '@') + item.seedcode;
          } else {
            catecode += (catecode == '' ? '' : '@') + item.categorycode;
          }
        }

        var skimcatecode = ''
        var skimseedcode = ''
        for (let i in this.tableDataSkim) {
          var item = this.tableDataSkim[i];
          if (item.seedcode) {
            skimseedcode += (skimseedcode == '' ? '' : '@') + item.seedcode;
          } else {
            skimcatecode += (skimcatecode == '' ? '' : '@') + item.categorycode;
          }
        }
        this.dialogFormVisible = false
        var value = catecode + '$' + seedcode + '$' + skimcatecode + '$' + skimseedcode;
        if (value == '$$$')
          value = '';
        this.$emit('AfterBasis', value);
      },
      //刷新按钮
      refreshBtn() {
        this.loading = false
      },
      //绑定查看数据
      initData(monthlybasis,CanEdit) {
        if(monthlybasis==null) monthlybasis="";

        this.CanEdit=CanEdit;
        this.initForm()
        this.dialogFormVisible = true

        getlistByCode({codes: monthlybasis}).then(response => {
          //明细
          response.data.obj.forEach(o => {
            if (o.isskim == 1) {
              this.tableDataSkim.push(o)
            } else {
              this.tableData.push(o)
            }
          })
        });
      },
      //初始化
      initForm() {
        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
        }
        this.refreshBtn()
        this.tableData = []
        this.tableDataSkim = []
        this.delUnitguids = []
      },
    },
    mounted() {
      this.tokenModel = JSON.parse(localStorage.getItem("hpapi_tokenModel"))
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.financeright = this.$checkRight('财务')
    },
    components: {
      JxcgooddetailSel,
      JxcgoodscategorySel,
    }
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/externaldept/SettingMenthodEdit.vue